import { render, staticRenderFns } from "./science.vue?vue&type=template&id=79b47fe6&scoped=true&"
import script from "./science.vue?vue&type=script&lang=js&"
export * from "./science.vue?vue&type=script&lang=js&"
import style0 from "./science.vue?vue&type=style&index=0&id=79b47fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b47fe6",
  null
  
)

component.options.__file = "science.vue"
export default component.exports